import { render, staticRenderFns } from "./companyManage.vue?vue&type=template&id=bc50d6f2&"
import script from "./companyManage.vue?vue&type=script&lang=js&"
export * from "./companyManage.vue?vue&type=script&lang=js&"
import style0 from "./companyManage.vue?vue&type=style&index=0&id=bc50d6f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports